import { ChevronDown, Download, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface AdvancedDropdownProps {
  onOpenImport: () => void;
  onOpenExport: () => void;
}

export function AdvancedDropdown({
  onOpenImport,
  onOpenExport,
}: AdvancedDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          aria-label="Erweiterte Aktionen"
        >
          Erweitert
          <ChevronDown className="ml-1 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={onOpenImport}>
          <Upload className="mr-2 h-4 w-4" />
          CSV importieren
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={onOpenExport}
          title="Exportiert die aktuell gespeicherten Regeln"
        >
          <Download className="mr-2 h-4 w-4" />
          CSV exportieren
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
